import { AdminPortal } from "../src/admin/AdminPortal";

export default function ServiceDeskApp() {
  return <AdminPortal />;
}
